import { FC } from 'react'
import { Menu } from '@reapit/elements'
import { NavigationMenu } from '../types'
import { useNavigationHandler } from '../utils'
import { isEmpty } from '@reapit-sales/utilities'

interface MainMenuMobileItemProps extends NavigationMenu {}

/**
 * Renders a single navigation Menu.Item in the top bar dropdown.
 *
 * Uses React Router’s `useHref` to generate the `href`, highlights
 * the item when it matches the active key, and calls back when clicked.
 *
 * @param onClick       Function to invoke when this menu item is clicked.
 * @param title          Text label to display for the navigation item.
 * @param href           Route path or URL this item links to.
 * @returns              A `<Menu.AnchorItem>` or `<Menu.Item>` if no `href` is provided.
 */
export const MainMenuMobileItem: FC<MainMenuMobileItemProps> = ({ onClick, title, href }) => {
  if (!isEmpty(href)) {
    return <Menu.AnchorItem {...useNavigationHandler(href, onClick)}>{title}</Menu.AnchorItem>
  }
  return <Menu.Item {...useNavigationHandler('', onClick)}>{title}</Menu.Item>
}
